<template>
  <div class="flow-list">
    <div v-if="productType" class="single-col">
      <ProductBlock
        v-for="(p, key) in products"
        :key="key"
        modifier="w"
        :info="p"
        :gaEvent="gaEvent"
      />
    </div>
    <TwoColumn v-else :products="products" :gaEvent="gaEvent" />
    <div v-if="loading" class="spinner">
      <img src="@/assets/img/loading-red.svg" />
      <div class="text">loading..</div>
    </div>
    <v-btn
      v-else-if="!inTheEnd"
      block
      color="primary"
      height="46"
      outlined
      @click="goToSeeMore"
    >
      看更多
    </v-btn>
  </div>
</template>

<script>
import TwoColumn from '@/components/layout/twoColumn.vue'
import ProductBlock from '@/components/ProductBlock'
export default {
  name: 'flow-list',
  components: {
    TwoColumn,
    ProductBlock,
  },
  props: {
    productType: {
      type: Boolean,
      default: false,
    },
    gaEvent: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    inTheEnd: {
      type: Boolean,
      default: true,
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  data: function() {
    return {}
  },
  methods: {
    goToSeeMore() {
      this.$emit('goToSeeMore')
    },
  },
}
</script>

<style lang="scss" scoped>
.flow-list {
  padding: 0;
  overflow-x: hidden;
}

.see-more {
  height: 45px;
  border-radius: 10px;
  border: solid 1px var(--primary);
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;

  &__text {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: var(--primary);
  }
}

.spinner {
  width: 100%;
  text-align: center;
  margin: auto;
  background-color: transparent;
}

.spinner > img {
  width: 32px;
  height: 32px;
  object-fit: contain;
  animation-name: spin;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  filter: grayscale(1);
}

.text {
  font-size: 12px;
  color: #9b9b9b;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
